import { render, staticRenderFns } from "./indexPC.vue?vue&type=template&id=fe793f90&scoped=true"
import script from "./indexPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./indexPC.vue?vue&type=style&index=0&id=fe793f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe793f90",
  null
  
)

export default component.exports